import { FC } from 'react'
import { Tag } from 'rsuite'
import { useFeatureIsOn } from '@growthbook/growthbook-react'

import { Product } from '../../../utils/types/Product'
import BestSellerTag from '../../BestSellerTag/BestSellerTag'
import { shouldShowBestSellerTag } from '../../BestSellerTag/utils/bestSellerAlgorithm'
import DeliveryInfoWithFlag from './DeliveryInfoWithFlag'

import tagStyles from '../../../styles/Tag.module.less'

interface ProductCardTagsProps {
  product: Product
  deliveryTime: number
  freeShipping: boolean
  isRFQProduct: boolean
  className?: string
  isBorderlessCard?: boolean
}

const ProductCardTags: FC<ProductCardTagsProps> = ({
  product,
  deliveryTime,
  freeShipping,
  isRFQProduct,
  className,
  isBorderlessCard = false,
}) => {
  const isBestSellerFeatureEnabled = useFeatureIsOn('show-best-seller-tags')

  const shouldShowBestSeller = shouldShowBestSellerTag(product)

  return (
    <>
      {shouldShowBestSeller && isBestSellerFeatureEnabled && (
        <BestSellerTag
          product={product}
          className={isBorderlessCard ? '' : `${tagStyles.tag} ${tagStyles['right-tag']}`}
        />
      )}

      {!(shouldShowBestSeller && isBestSellerFeatureEnabled) && (
        <Tag
          data-testid="product-card-right-tag"
          data-testvalue={isRFQProduct ? -1 : deliveryTime}
          className={className}
        >
          <DeliveryInfoWithFlag
            deliveryTime={deliveryTime}
            freeShipping={freeShipping}
            isRFQProduct={isRFQProduct}
          />
        </Tag>
      )}
    </>
  )
}

export default ProductCardTags
